import * as React from 'react';
import { useState } from "react";
import Modal from 'antd/lib/modal';
import Radio from 'antd/lib/radio';
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import Select from "antd/lib/select";
import Divider from "antd/lib/divider";
import Form from "antd/lib/form";
import Spin from "antd/lib/spin";
import Icon from "antd/lib/icon";
import {
    Props,
} from 'one-ui';
import Dialpad from "@2fd/ant-design-icons/lib/Dialpad";
import CheckCircleOutline from "@2fd/ant-design-icons/lib/CheckCircleOutline";
import Check from "@2fd/ant-design-icons/lib/Check"
import cardIcon1 from 'one-ui-svg/images/visa.png';
import cardIcon2 from "one-ui-svg/images/mastercard.png";
import cardIcon3 from "one-ui-svg/images/amex.png";
import cardIcon4 from "one-ui-svg/images/discover.png";
import MaskedInput from 'antd-mask-input';
import {
    setBillingPaymentAction,
    setBillingPaymentSuccessAction,
} from 'one-state-billing-details';
import {
    useDispatch,
} from 'react-redux';
import { useCtx } from 'one-ui-provider';

const { Option } = Select;
const { TextArea } = Input;
const antIconLoading = <Icon type="loading" style={{ fontSize: 24 }} spin />


export interface PaymentProps extends Props {
    title: string;
    billpayment: boolean;
    billpaymentsuccess: boolean;
}



export const PaymentCard = ({
    title,
    billpayment,
    billpaymentsuccess,
}: PaymentProps): JSX.Element => {
    const dispatch = useDispatch();
    const { resolver } = useCtx();
    const [paymenttype, setPaymenttype] = useState(true);
    const [cardnumber, setCardnumber] = useState(true);
    const [expnumber, setExpnumber] = useState(true);
    const [secnumber, setSecnumber] = useState(true);
    const [processpayment, setProcessPayment] = useState(true);
    const [initiatepayment, setInitiatepayment] = useState(true);
    const [paybill, setPaybill] = useState('full');
    const [ccn, setCcn] = useState('');
    const [expm, setExpm] = useState('');
    const [expy, setExpy] = useState('');
    const [secn, setSecN] = useState('');
    const [paybillamount, setPaybillamount] = useState('');
    const [payotheramount, setPayotheramount] = useState('');
    const handleBillingCancel = (e: any) => {
        dispatch(setBillingPaymentAction(false));
        setPaymenttype(true);
        setCardnumber(true);
        setExpnumber(true);
        setSecnumber(true);
        setCcn('');
        setExpm('');
        setExpy('');
        setSecN('');
        setPaybillamount('');
        setPayotheramount('');
        setPaybill('full');

    };
    const handleBillingSuccessCancel = (e: any) => {
        dispatch(setBillingPaymentSuccessAction(false));
    }
    const onCardNumberClick = () => {
        setCardnumber(false);
    }
    const onCardNumberResetClick = () => {
        setCcn('');
        setProcessPayment(true);
    }
    const onExpirationNumberClick = () => {
        setExpnumber(false);
    }
    const onExpirationResetClick = () => {
        setExpm('');
        setExpy('');
        setProcessPayment(true);
    }
    const onSecurityNumberClick = () => {
        setSecnumber(false);
    }
    const onSecurityResetClick = () => {
        setSecN('');
        setProcessPayment(true);
    }
    const OnPayBillChange = (event: string) => {
        setPaybill(event);
        setPaybillamount('');
    }
    const onCcnChange = (event: any) => {
        setCcn(event.target.value);
        if (ccn?.length >= 18) {
            setProcessPayment(true);
        }
    }
    const onExpmChange = (event: any) => {
        //To check it is a number and other validation is to remove the last value.
        if (!Number(event.target.value) && event?.target?.value?.length != 0) {
            if (event.target.value != 0) {
                return;
            }
        }
        // For dot
        if (event.target.value?.indexOf('.') !== -1) {
            return;
        }
        setExpm(event.target.value);
        if (expm?.length >= 1) {
            setProcessPayment(true);
        }
    }
    const onExpyChange = (event: any) => {
        if (!Number(event.target.value) && event?.target?.value?.length != 0) {
            if (event.target.value != 0) {
                return;
            }
        }
        // For dot
        if (event.target.value?.indexOf('.') !== -1) {
            return;
        }
        setExpy(event.target.value);
        if (expy?.length >= 1) {
            setProcessPayment(true);
        }
    }
    const onSecnChange = (event: any) => {
        if (!Number(event.target.value) && event?.target?.value?.length != 0) {
            if (event.target.value != 0) {
                return;
            }
        }
        // For dot
        if (event.target.value?.indexOf('.') !== -1) {
            return;
        }
        setSecN(event.target.value);
        if (secn?.length >= 2) {
            setProcessPayment(true);
        }
    }
    const onPayOtherAmountChange = (event: any) => {
        if (!Number(event.target.value) && event?.target?.value?.length != 0) {
            return;
        }
        setPayotheramount(event.target.value);
    }
    const onPayBillAmountChange = (event: any) => {
        if (!Number(event.target.value) && event?.target?.value?.length != 0) {
            return;
        }
        setPaybillamount(event.target.value);
    }
    const CheckCCNValid = (event: any) => {
        event = event.split(" ").join("");
        if (Number(event)) {
            if (event?.length == 16) {
                return "success";
            } else {
                return "";
            }
        } else {
            return "";
        }
    }

    //Check for Process Enable
    if (secn?.length == 3 && processpayment) {
        if (expm?.length == 2 && expy?.length == 2) {
            if (ccn?.length == 19) {
                setProcessPayment(false);
            }
        }
    }

    const payPayment = () => {
        setInitiatepayment(false);
        setTimeout(() => {
        setCardnumber(true);
        setExpnumber(true);
        setSecnumber(true);
        setInitiatepayment(true);
        setProcessPayment(true);
        setCcn('');
        setExpm('');
        setExpy('');
        setSecN('');
        dispatch(setBillingPaymentAction(false));
        dispatch(setBillingPaymentSuccessAction(true));
        }, 2000);
    }
    const billPaymentSuccess = () => {
        dispatch(setBillingPaymentSuccessAction(false));
    }


    return (
        <>
            <Modal
                visible={billpayment}
                footer={null}
                centered
                closable={true}
                onCancel={handleBillingCancel}
                destroyOnClose
            >
                <div className="billing-box" style={{ width: "460px" }}>
                    <div className="text-2xl text-black-85 text-center font-medium mb-20">{title}</div>
                    <div className="flex justify-between text-sm text-black-85 mb-20">
                        <div><span className="text-black-40">Patient Name:</span> Grand Central Mike</div>
                        <div><span className="text-black-40">Patient MRN:</span> E2622</div>
                    </div>
                    <div className="text-center">
                        <Radio.Group defaultValue={1}>
                            <Radio value={1} onChange={() => setPaymenttype(true)}>Pay Bill</Radio>
                            <Radio value={2} onChange={() => setPaymenttype(false)}>Pay Other</Radio>
                        </Radio.Group>
                    </div>
                    <Divider style={{ margin: "1rem 0" }} />
                    <Row type="flex" gutter={[26, 4]} style={{ display: (paymenttype === true ? "" : "none") }}>
                        <Col span={8}>
                            <div className="text-sm text-black-40">Payment type</div>
                        </Col>
                        <Col span={8}>
                            <div className="text-sm text-black-40">Balance Due</div>
                        </Col>
                        <Col span={8}>
                            <div className="text-sm text-black-40">Amount to pay</div>
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[26, 4]} align="middle" style={{ display: (paymenttype === true ? "" : "none") }}>
                        <Col span={8}>
                            <Select defaultValue="full" style={{ width: '100%' }} onChange={OnPayBillChange}>
                                <Option value="full">Pay Full</Option>
                                <Option value="partial">Pay Partial</Option>
                            </Select>
                        </Col>
                        <Col span={8}>
                            <div className="text-lg text-primary">$238.55</div>
                        </Col>
                        <Col span={8}>
                            <Input suffix="USD" maxLength={8} onChange={onPayBillAmountChange} disabled={paybill === 'full' ? true : false} value={paybill === 'full' ? '$238.55' : paybillamount} />
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[8, 16]} style={{ display: (paymenttype === true ? "none" : "") }}>
                        <Col span={6}>
                            <div className="text-sm text-black-40 pt-5">Amount:</div>
                        </Col>
                        <Col span={8}>
                            <Input maxLength={8} onChange={onPayOtherAmountChange} value={payotheramount} suffix="USD" />
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[8, 16]} style={{ display: (paymenttype === true ? "none" : "") }}>
                        <Col span={6}>
                            <div className="text-sm text-black-40 pt-5">Comments:</div>
                        </Col>
                        <Col span={18}>
                            <TextArea rows={3} placeholder="Enter details about this payment..." />
                        </Col>
                    </Row>
                    <Divider style={{ margin: "1.6rem 0" }} />
                    <Row type="flex" gutter={[8, 20]} align="middle">
                        <Col span={6}>
                        </Col>
                        <Col span={13}>
                            <img src={resolver(cardIcon1)} alt={'Icon'} style={{ width: "22px" }} className="mr-5" draggable="false"/>
                            <img src={resolver(cardIcon2)} alt={'Icon'} style={{ width: "22px" }} className="mr-5" draggable="false"/>
                            <img src={resolver(cardIcon3)} alt={'Icon'} style={{ width: "22px" }} className="mr-5" draggable="false"/>
                            <img src={resolver(cardIcon4)} alt={'Icon'} style={{ width: "22px" }} draggable="false"/>
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[8, 16]}>
                        <Col span={6}>
                            <div className="text-sm text-black-40 pt-5">Card Number:</div>
                        </Col>
                        <Col span={13}>
                            <Form.Item validateStatus={CheckCCNValid(ccn)} className="input-validate-styled">
                                <MaskedInput
                                    mask="1111 1111 1111 1111"
                                    placeholderChar="-"
                                    placeholder="---- ---- ---- ----"
                                    size="default"
                                    disabled={cardnumber}
                                    onChange={onCcnChange}
                                    value={ccn}
                                />
                                <Check className="input-validate-styled__icon" />
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Button type="primary" block ghost onClick={() => onCardNumberClick()} style={{ display: (cardnumber === true ? "" : "none"), padding: "0 6px" }}>
                                <Dialpad className="text-lg" />
                                <span style={{ marginLeft: ".2rem" }}>Start</span>
                            </Button>
                            <Button block style={{ display: (cardnumber === true ? "none" : ""), padding: "0 6px" }} onClick={() => onCardNumberResetClick()}>
                                Reset
                            </Button>
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[8, 16]}>
                        <Col span={6}>
                            <div className="text-sm text-black-40 pt-5">Expiration Date:</div>
                        </Col>
                        <Col span={13}>
                            <Row type="flex" gutter={[8, 0]}>
                                <Col span={8}>
                                    <Form.Item validateStatus={expm?.length == 2 ? "success" : ""} className="input-validate-styled">
                                        <Input maxLength={2} placeholder="MM" disabled={expnumber} onChange={onExpmChange} value={expm} />
                                        <Check className="input-validate-styled__icon" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item validateStatus={expy?.length == 2 ? "success" : ""} className="input-validate-styled">
                                        <Input maxLength={2} placeholder="YY" disabled={expnumber} onChange={onExpyChange} value={expy} />
                                        <Check className="input-validate-styled__icon" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Button type="primary" block ghost onClick={() => onExpirationNumberClick()} style={{ display: (expnumber === true ? "" : "none"), padding: "0 6px" }}>
                                        <Dialpad className="text-lg" />
                                        <span style={{ marginLeft: ".2rem" }}>Start</span>
                                    </Button>
                                    <Button block style={{ display: (expnumber === true ? "none" : ""), padding: "0 6px" }} onClick={() => onExpirationResetClick()}>
                                        Reset
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row type="flex" gutter={[8, 16]}>
                        <Col span={6}>
                            <div className="text-sm text-black-40 pt-5">Security Code:</div>
                        </Col>
                        <Col span={13}>
                            <Row type="flex" gutter={[8, 0]}>
                                <Col span={16}>
                                    <Form.Item validateStatus={secn?.length == 3 ? "success" : ""} className="input-validate-styled">
                                        <Input maxLength={3} placeholder="Security Code" disabled={secnumber} onChange={onSecnChange} value={secn} />
                                        <Check className="input-validate-styled__icon" />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Button type="primary" block ghost onClick={() => onSecurityNumberClick()} style={{ display: (secnumber === true ? "" : "none"), padding: "0 6px" }}>
                                        <Dialpad className="text-lg" />
                                        <span style={{ marginLeft: ".2rem" }}>Start</span>
                                    </Button>
                                    <Button block style={{ display: (secnumber === true ? "none" : ""), padding: "0 6px" }} onClick={() => onSecurityResetClick()}>
                                        Reset
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Divider style={{ margin: "1.6rem 0" }} />
                    <div className="flex justify-end" style={{ display: (initiatepayment === true ? "" : "none") }}>
                        <Button className="mr-20" onClick={handleBillingCancel}>Cancel</Button>
                        <Button type="primary" disabled={processpayment} onClick={() => payPayment()}>Process Payment</Button>
                    </div>
                    <div className="loading-block flex items-center justify-center" style={{ display: (initiatepayment === true ? "none" : "") }}>
                        <div className="loading-block__ico">
                            <Spin indicator={antIconLoading} />
                        </div>
                        <div className="loading-block__note ml-10">Processing the payment...</div>
                    </div>
                </div>
            </Modal>
            <Modal
                visible={billpaymentsuccess}
                footer={null}
                centered
                closable={true}
                onCancel={handleBillingSuccessCancel}
                destroyOnClose
            >
                <div className="billing-box" style={{ width: "460px" }}>
                    <div className="text-2xl text-black-85 text-center font-medium mb-20">Collect Payment</div>
                    <div className="flex justify-between text-sm text-black-85 mb-5">
                        <div><span className="text-black-40">Patient Name:</span> Grand Central Mike</div>
                        <div><span className="text-black-40">Balance Due:</span> $0.00</div>
                    </div>
                    <div className="flex justify-between text-sm text-black-85 mb-20">
                        <div><span className="text-black-40">Patient MRN:</span> E2622</div>
                    </div>
                    <Divider style={{ margin: "1.6rem 0" }} />
                    <div className="flex justify-center items-center">
                        <CheckCircleOutline className="text-success" style={{ fontSize: '2.6rem' }} />
                        <div className="text-xl font-medium ml-10 text-black-85">Successful payment</div>
                    </div>
                    <Divider style={{ margin: "1.6rem 0" }} />
                    <table className="text-sm text-black-85">
                        <tbody>
                            <tr>
                                <td style={{ paddingRight: "1rem" }}>
                                    <span className="text-black-40">Amount paid:</span>
                                </td>
                                <td>
                                    <div className="text-black-85">$238.55</div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ paddingRight: "1rem" }}>
                                    <span className="text-black-40">Confirmation ID:</span>
                                </td>
                                <td>
                                    <div className="text-black-85">46456757869869</div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ paddingRight: "1rem" }}>
                                    <span className="text-black-40">Transaction ID:</span>
                                </td>
                                <td>
                                    <div className="text-black-85">1A35CD3253EF354364</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <Divider style={{ margin: "1.6rem 0" }} />
                    <div className="flex justify-end">
                        <Button type="primary" onClick={() => billPaymentSuccess()}>Complete</Button>
                    </div>
                </div>
            </Modal>
        </>
    );
}